import { Box, Typography, tokens } from '@cast/design-system';

import { LabelExpressionConnectorVariant } from './types';

type LabelExpressionConnectorProps = {
  variant: LabelExpressionConnectorVariant;
};

const CONNECTOR_BG = tokens.theme.bg.structural.surfaceRaised;

export const LabelExpressionConnector = ({
  variant,
}: LabelExpressionConnectorProps) => {
  return (
    <Box
      sx={{
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        minHeight: 44,
        alignSelf: 'baseline',
        alignItems: 'center',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          bottom: 0,
          width: 10,
          bgcolor: CONNECTOR_BG,
          zIndex: 0,
        }}
      />
      <Box
        sx={{
          zIndex: 1,
          bgcolor: CONNECTOR_BG,
          px: 6,
          py: 3,
          borderRadius: '4px',
        }}
      >
        <Typography variant="P12M" color={tokens.theme.fg.structural.secondary}>
          {variant}
        </Typography>
      </Box>
    </Box>
  );
};
